import { render, staticRenderFns } from "./IdentificationIdentityData.vue?vue&type=template&id=8018d9b6&scoped=true"
import script from "./IdentificationIdentityData.vue?vue&type=script&lang=js"
export * from "./IdentificationIdentityData.vue?vue&type=script&lang=js"
import style0 from "./IdentificationIdentityData.vue?vue&type=style&index=0&id=8018d9b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8018d9b6",
  null
  
)

export default component.exports